export enum PeriodOverPeriodMetricType {
	HISTORICAL = 'historical',
	DELTA = 'delta',
	PERCENT_CHANGE = 'percentChange',
	P_VALUE = 'pValue',
	SIGNIFICANCE = 'significance',
}